import { render, staticRenderFns } from "./iconDeleteAddress.vue?vue&type=template&id=3eb490dc&scoped=true"
import script from "./iconDeleteAddress.vue?vue&type=script&lang=js"
export * from "./iconDeleteAddress.vue?vue&type=script&lang=js"
import style0 from "./iconDeleteAddress.vue?vue&type=style&index=0&id=3eb490dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb490dc",
  null
  
)

export default component.exports